<template>
  <div class="create px-8 py-4">
    <div>
      <lCrumbs :breadcrumb="breadcrumbItems" />
      <div class="mb-8 text-xl text-black">Create Leaderboard</div>
      <div class="mt-12">
        <div class="md:flex w-full">
          <div class="w-full md:w-1/2">
            <div class="md:mx-12">
              <div class="item md:flex md:items-center w-full mb-12">
                <div class="w-full md:w-1/4 mr-4">
                  <label class="text-black font-bold" for="">Title: </label>
                </div>
                <div class="w-full">
                  <linput
                    type="text"
                    name="first_name"
                    v-model="form.title"
                    :errorMessage="errors.title"
                    :error="errors.title"
                    placeholder="title"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full text-center">
        <lms-button class="mb-12" @click="handleSubmit" textColor="#fff"
          >Create
        </lms-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import FormActions from "@/mixins/FormActions";
export default {
  mixins: [FormActions],
  data() {
    return {
      activeTab: 2,
      form: {},
      errors: {},
      breadcrumbItems: [
        {
          disabled: true,
          to: "/tenant/leaderboard",
          text: "All Leaderboards",
        },
        {
          disabled: true,
          to: "#",
          text: "Create Leaderboard",
        },
      ],
      items: [
        {
          text: "Exercise",
          value: "exercise",
        },
        {
          text: "Lesson",
          value: "lesson",
        },
        {
          text: "Quiz",
          value: "quiz",
        },
        {
          text: "Survey",
          value: "survey",
        },
      ],
    };
  },
  components: {
    linput: () => import("@/components/general/input"),
    steps: () => import("@/components/general/steps"),
    LmsButton: () => import("@/components/general/button"),
    LmsSelect: () => import("@/components/forms/select"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
  },
  methods: {
    ...mapActions(["tenantCreateLeaderboard"]),
    ...mapMutations(["updateLoader"]),
    async handleSubmit() {
      this.errors = [];
      this.updateLoader(true);
      let res = await this.tenantCreateLeaderboard(this.form);
      this.updateLoader(false);
      if (res.status == 201 || res.status == 200) {
        this.$Bus.$emit("notify", {
          type: "success",
          message: "LeaderBoard created successfully",
        });

        this.$router.push({
          name: "tenant-leaderboard-home",
        });
      } else {
        this.errors = res.data.errors[0].source;
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
            ? res.data.errors[0].title
            : "An error occured",
        });
      }
    },
  },
};
</script>
